<template class="linsss">
  <div>
  <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>
	<div class="container newMallBox" v-show="!special || !special['index/index']">
		<div class="newMallHeaderBox">
			<div class="newMallmarqueebox">
		  	<marquee scrolldelay="200">Enjoy one-stop sourcing experience exclusive for the industry!</marquee>
		  </div>
		  <div class="newMallLogoBox">
		  	<!--logo-->
		  <!-- 	<div class="newMallLogoLeft">
		  		<img src="https://img.duoyp.com/home/common/alioss_site_mobile_logo.png?1783662893" alt="DYP Mall" title="DYP Mall"/>
		  	</div> -->
		  	<!--logo-->
		  	
		  	<!--搜索-->
		  	<div class="newMallsearchLeft" @click="onSearch">
		  		<div class="searchIcon">
		  			<img src="../../../assets/image/searchicon.png" alt="Search" title="Search"/>
		  		</div>
		  		<input type="text" placeholder="What are you looking for?" />
		  	</div>
		  	<!--搜索 end-->
		  	
		  </div>
		  
		  <!--导航栏-->
		  <index-menutwo  :items="navs"></index-menutwo>
		  <!--导航栏 end-->		  
		</div>
		
		<!--banner-->
		<!-- <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner> -->
		<!--banner end-->
		
		<div class="NewContentBox">
			<!--发现好货-->
			<!--<div class="Findgoodgoods">
				<div class="FindgoodgoodsBox">
					
					<div class="FindgoodgoodsBannerRight">
						<div class="FindgoodgoodsHeader">
							<h3>Featured</h3>
							<p>Explore new product</p>
						</div>
						
						<div class="FindgoodgoodsListBox">
							<ul>
								<li @click="productdetails(583)">
									<div class="Findgoodgoodscontent">
										<div class="panicbuyingproductImg">
											<img src="https://img.duoyp.com/home/store/goods/274/20220308/alioss_274_2022030811113612326.jpg" />
										</div>
										<p class="panicbuyingproductName">86寸智能黑板</p>
										<p class="panicbuyingproductPic">$20000.00</p>
									</div>
								</li>
								<li @click="productdetails(9484)">
									<div class="Findgoodgoodscontent">
										<div class="panicbuyingproductImg">
											<img src="https://img.duoyp.com/home/store/goods/360/20220418/alioss_360_2022041818104679575.jpg" />
										</div>
										<p class="panicbuyingproductName">X-8 Coupe</p>
										<p class="panicbuyingproductPic">$25000.00</p>
									</div>
								</li>
								<li @click="productdetails(12223)">
									<div class="Findgoodgoodscontent">
										<div class="panicbuyingproductImg">
											<img src="https://img.duoyp.com/home/store/goods/4598/20220427/alioss_4598_2022042714020377830.jpg" />
										</div>
										<p class="panicbuyingproductName">幻彩灯带 户外防水全彩灯带 气相胶挤出2020</p>
										<p class="panicbuyingproductPic">$32.00</p>
									</div>
								</li>
								<li @click="productdetails(15463)">
									<div class="Findgoodgoodscontent">
										<div class="panicbuyingproductImg">
											<img src="https://img.duoyp.com/home/store/goods/1313/20220601/alioss_1313_2022060113365145655.jpg?x-oss-process=image/resize,m_pad,w_240,h_240" />
										</div>
										<p class="panicbuyingproductName">双子星系列-双面异步弱溶剂喷印机 Binary Star DA-3200UV</p>
										<p class="panicbuyingproductPic">$648000.00</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				
					
					
					<div class="FindgoodgoodsBanner">
						<Floor-banner v-if="banners && banners.length > 0" :items="floorAds"></Floor-banner>
					</div>
					
					
				</div>
			</div>-->
			<!--发现好货 end-->
			
			<!--为您推荐-->
			<div class="RecommendedForYouBox">
				<div class="RecommendedForYouBoxTitle">
					<h3>Recommend for You</h3>
				</div>
				<div class="RecommendedProduct" id="demo">
					<ul>						
						<li :index="index" v-bind:key="index" v-for="(item, index) in Recommendedpro" v-if="index%2==0">
							<div class="RecommendedProductContent">
								<div class="RecommendedProductImg"  @click="productdetails(item.goods_id)">
									<img :src="item.goods_img_480" />
								</div>
								<div class="RecommendedProductName" @click="productdetails(item.goods_id)">
									<p>{{item.goods_name}}</p>
								</div>
								<p class="RecommendedProductPic">${{item.goods_price}}</p>
								<div class="RecommendedProductStop" @click="goShopDetail(item.store_id)">
									<span class="StopName">{{item.store_name}}</span>
									<span class="gostop">More Products</span>
								</div>	
							</div>
						</li>
					</ul>
					<ul>						
						<li :index="index" v-bind:key="index" v-for="(item, index) in Recommendedpro" v-if="index%2==1">
							<div class="RecommendedProductContent">
								<div class="RecommendedProductImg"  @click="productdetails(item.goods_id)">
									<img :src="item.goods_img_480" />
								</div>
								<div class="RecommendedProductName" @click="productdetails(item.goods_id)">
									<p>{{item.goods_name}}</p>
								</div>
								<p class="RecommendedProductPic">${{item.goods_price}}</p>
								<div class="RecommendedProductStop" @click="goShopDetail(item.store_id)">
									<span class="StopName">{{item.store_name}}</span>
									<span class="gostop">More Products</span>
								</div>	
							</div>
						</li>
					</ul>				
				</div>
				<div class="Loading" v-if="Loadingshow">Loading...</div>
				<div class="Loading" v-if="NoLoadingshow">End</div>	
			</div>
			<!--为您推荐 end-->
		</div>
		<!-- 版权信息 -->
    <div class="copyright" v-if="config">
        <div><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
        <div><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div>
    <div>{{config.flow_static_code}}</div>
    </div>
	</div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import { homeIndexProductListpage } from '../../../api/homeindex'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import IndexMenutwo from './IndexMenutwo'
import indexInformation from './IndexInformation'
import IndexBanner from './IndexBanner'
import FloorBanner from './FloorBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
export default {
  name: 'HomeIndex',
  data () {
    return {
      isshowBacktop: true,
      popular: '',
      Recommendedpro:'',
      sale: 'goods_salenum',
      recently: 'goods_addtime',
      Loadingshow:false,
      NoLoadingshow:false,
      indexshowbox:false,
      currentpages:1,
      langdata:this.$route.query.lang,
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    IndexBanner,
    FloorBanner,
    IndexMenu,
    IndexMenutwo,
    indexInformation,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle
  },
  mounted () {
  	// if(this.langdata!="en"){
  	// 	document.getElementById("CommonFooterBox").style.display = "none";
  	// }else{
  	// 	document.getElementById("CommonFooterBox").style.display = "block";
  	// }
  },
  beforeCreate:function(){
  	
  },
  created: function () {
		//	链接存在lang=en参数，就留在国际版页面，否则跳转到国内版
  	// if(this.langdata!="en"){ 		
			// window.location.href="https://h5.duoyp.com";
  	// }else{
  	// 	this.indexshowbox=true;
  	// }
  	window.scrollTo(0,0)
  	
  	
  	homeIndexProductListpage(this.currentpages).then((res) => {
			this.Recommendedpro=res.result.good_products;
			window.addEventListener("scroll",this.pageScroll);
	  })
  	
    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    }),
    onSearch () {
      this.$router.push({ name: 'HomeSearch', params: { isFromHome: true } })
    },
    //产品详情
    productdetails(productids){
    	this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: productids } })
    },
    //十大专馆
    livedetails(lives){
    	this.$router.push({ name: 'HomeLiveList', query: { class_id: lives} })
    },
    //进店
    goShopDetail (store_id) {
      this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
    },
    pageScroll(){
	    // 获取滚动的距离
	    let scrollTop=document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;;
	    // 获取滚动的高度（获取整个html的高度）
	    let scrollHeight=document.getElementById('demo').scrollHeight;
	    // 获取屏幕(浏览器)高度
	    let clienHeight=document.documentElement.clientHeight;
	    // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
	    if(scrollTop+clienHeight-scrollHeight >=100){
	    	window.removeEventListener("scroll",this.pageScroll);
	    	//我到底了
	    	if(this.currentpages<=10){
	    		this.currentpages=this.currentpages+1;
	      	this.Loadingshow = true;
	    		this.prolistmore();
	    	}else{
	    		this.Loadingshow = false;
	    		this.NoLoadingshow=true;
	    	}
	      	      
	      //滚动至底部后请求数据
		    }
		},
		prolistmore:function(){		
			homeIndexProductListpage(this.currentpages).then((res) => {
				if(res.result.good_products.length<10){
					this.currentpages=12;
				}
				this.Recommendedpro=this.Recommendedpro.concat(res.result.good_products);
				window.addEventListener("scroll", this.pageScroll);
				this.Loadingshow = false;
		  })
			
		}
    
  }
}

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?6c9183b3069d2ff7d1f692bf75b9ebd8";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>


<style scoped>
.marqueebox{font-size: 0.5rem;position: fixed;top: 0px;left: 0px;width: 100%;background: rgba(0,0,0,0.5);}	
.marqueebox marquee{line-height: 1rem;font-size: 0.6rem;color: #fff;padding-top: 0.1rem;}
.copyright{font-size:.5rem;color:#999;text-align: center;padding:.8rem 0;line-height: 0.7rem;display: none;}
.indexlogobox{padding-bottom: 0.3rem;}
.indexlogobox img{width: 100%;max-width: 8rem;}
.searchBannerBox{padding-bottom: 0rem;}
.indexlogobox p{font-size:.6rem;color: #fff;line-height: 0.8rem;margin-top: 0.2rem;}
.indexbjback{background-image: url(../../../assets/image/home/headerback.jpg);background-color: #aeb7be;background-repeat: no-repeat;
background-size: 100% auto;padding-top: 1.7rem;background-position-y: -3rem;display: none;}
.indexheaderbox{padding: 1rem 0.8rem;padding-top: 0rem;padding-bottom: 0px;}
.advertisementBox{text-align: center;margin: 0.3rem 0;}
.advertisementBox img{display: inline-block;max-width: 100%;}



/*新*/
.newMallHeaderBox{background: #e60012;padding: 0.3rem 0.5rem;position: relative;padding-top: 1.5rem;padding-bottom: 0rem;}
.newMallmarqueebox{position: absolute;left: 0;top: 0;width: 100%;font-size: 0.5rem;width: 100%;background: rgba(0,0,0,0.5);box-sizing: border-box;padding-left: 1.1rem;background-image: url(../../../assets/image/lab.png);background-position: left 3px center;background-repeat: no-repeat;background-size: 0.8rem;}
.newMallmarqueebox marquee{line-height: 1rem;font-size: 0.6rem;color: #fff;padding-top: 0.1rem;}
.newMallLogoBox{padding: 0.3rem 0;}
.newMallLogoLeft{display: inline-block;width: 35%;vertical-align: middle;}
.newMallLogoLeft img{width: 100%;}
.newMallsearchLeft{display: inline-block;vertical-align: middle;position: relative;background: #fff;padding: 0.1rem 0.7rem;border-radius: 1rem;padding-left: 1.9rem;box-sizing: border-box;width: 60%;margin-left: 2%;}
.searchIcon{position: absolute;width: 1.1rem;height: 1.1rem;left: 0.5rem;top: 0.2rem;}
.searchIcon img{width: 100%;}
.newMallsearchLeft input{height: 1.5rem;padding: 0;color: #000;width: 100%;outline: none;border: none;font-size: 0.5rem;line-height: 1.5rem;}

.NewContentBox{padding: 0.3rem 0.5rem;background: #eff2f4;}
/*疯狂抢购*/
.panicbuyingBox{background-image: url(../../../assets/image/gkqgou.png);background-repeat: no-repeat;
background-size: 100% 100%;padding: 0.1rem 0 0.3rem 0;margin-top: 0.2rem;}
.panicbuyingTitle{text-align: center;}
.panicbuyingTitle p{font-weight: 800;font-size: 1.2rem;color: #fff;letter-spacing: 2px;}
.panicbuyingproduct ul{margin: 0;padding: 0;overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
.panicbuyingproduct ul li{width: 33.3%;padding: 0.5rem;box-sizing: border-box;}
.panicbuyingproduct ul li .panicbuyingproductImg{width: 100%;min-height: 5rem;line-height: 5rem;}
.panicbuyingproduct ul li .panicbuyingproductImg img{width: 100%;vertical-align: middle;}
.panicbuyingproduct ul li .panicbuyingproductName{font-size: 0.7rem;color: #4d504c;margin-top: 0.2rem;line-height: 1.2rem;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;}
.panicbuyingproduct ul li .panicbuyingproductPic{margin-top: 0.2rem;font-size: 0.7rem;font-weight: 600;color: #e60012;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;}

/*628 行业潮流新风向*/
.IndustrytrendBox{margin-top: 0.7rem;background: #e60012;border-radius: 5px;overflow: hidden;}
.IndustrytrendTitleBox{text-align: center;background-image: url(../../../assets/image/IndustrytrendTitle.png);background-repeat: no-repeat;
background-size: 100% 100%;padding: 0.5rem 0;padding-bottom: 1.2rem;}
.IndustrytrendTitleBox img{width: 70%;}
.IndustrytrendListBox{padding: 0.3rem;margin-top: -1.3rem;}
.IndustrytrendListBox ul{margin: 0;padding: 0;overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
.IndustrytrendListBox ul li{width: 25%;padding: 0.2rem;box-sizing: border-box;}
.IndustrytrendListBox ul li .Industrytrendproduct{background: #fff;padding: 0 0.2rem;border-radius: 3px;}
.IndustrytrendListBox ul li .IndustrytrendImg{width: 100%;min-height: 3.5rem;line-height: 3.5rem;}
.IndustrytrendListBox ul li .IndustrytrendImg img{width: 100%;vertical-align: middle;}
.IndustrytrendListBox ul li .IndustrytrendName{font-size: 0.6rem;color: #000;margin-top: 0.2rem;line-height: 1.2rem;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;text-align: center;font-weight: bold;}

/*发现好货*/
.Findgoodgoods{margin-top: 0.7rem;}
.FindgoodgoodsBox{overflow: auto;position: relative;}
.FindgoodgoodsBanner{width: 49%;display: inline-block;position: absolute;right: 0px;top: 0px;height: 100%;box-sizing: border-box;overflow: hidden;border-radius: 5px;}
.FindgoodgoodsBanner img{width: 100%;}
.FindgoodgoodsBannerRight{width: 49%;display: inline-block;float: left;background: url(../../../assets/image/FindgoodgoodsBannerRight.jpg);background-repeat: no-repeat;
background-size: 100% 100%;padding: 0.5rem 0rem;box-sizing: border-box;}
.FindgoodgoodsHeader{padding: 0 0.3rem;}
.FindgoodgoodsHeader h3{font-weight: 800;font-size: 1rem;color: #fff;letter-spacing: 1px;margin: 0;line-height: 1.3rem;padding: 0;margin: 0;}
.FindgoodgoodsHeader p{display: inline-block;padding: 0;;padding-right: 1.1rem;background: url(../../../assets/image/righticon.png);background-repeat: no-repeat;
background-size: 0.7rem auto;background-position: right center;font-size: 0.7rem;color: #fff;margin: 0;}
.FindgoodgoodsListBox{padding: 0 0.2rem;margin-top: 0.2rem;}
.FindgoodgoodsListBox ul{margin: 0;padding: 0;overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
.FindgoodgoodsListBox ul li{width: 50%;padding: 0.1rem;box-sizing: border-box;float: left;}
.FindgoodgoodsListBox ul li .Findgoodgoodscontent{background: #fff;border-radius: 5px;overflow: hidden;padding: 0 0.1rem;}
.FindgoodgoodsListBox ul li .panicbuyingproductImg{width: 100%;min-height: 4.2rem;line-height: 4.1rem;}
.FindgoodgoodsListBox ul li .panicbuyingproductImg img{width: 100%;vertical-align: middle;}
.FindgoodgoodsListBox ul li .panicbuyingproductName{font-size: 0.5rem;color: #4d504c;margin-top: 0.2rem;line-height: 1rem;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;}
.FindgoodgoodsListBox ul li .panicbuyingproductPic{margin-top: 0.2rem;font-size: 0.5rem;font-weight: 600;color: #e60012;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;}

/*为您推荐*/
.RecommendedForYouBox{margin-top: 0.7rem;padding-bottom: 1rem;}
.RecommendedForYouBoxTitle{text-align: center;}
.RecommendedForYouBoxTitle h3{font-weight: bold;font-size: 1rem;color: #334241;letter-spacing:0px;display: inline-block;padding: 0 1.5rem;background: url(../../../assets/image/titlebj.png);background-repeat: no-repeat;background-size: 100% auto;background-position: left center;padding-bottom: 0.1rem;}

.RecommendedProduct ul{margin: 0;padding: 0;overflow: auto;}
.RecommendedProduct ul li{padding: 0rem;box-sizing: border-box;display: block;margin-top: 0.5rem;padding:  0 0.2rem;width: 50%;float: left;}
.RecommendedProduct ul li .RecommendedProductContent{background: #fff;box-sizing: border-box;padding: 0.35rem;border-radius: 8px;}
.RecommendedProduct ul li .RecommendedProductImg{width: 100%;min-height: 7rem;line-height: 7rem;}
.RecommendedProduct ul li .RecommendedProductImg img{width: 100%;vertical-align: middle;}
.RecommendedProduct ul li .RecommendedProductName{}
.RecommendedProduct ul li .RecommendedProductName p{font-size: 0.5rem;color: #414847;margin-top: 0.2rem;overflow: hidden;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;line-height: 1rem;}
.RecommendedProduct ul li .RecommendedProductPic{margin-top: 0.2rem;font-size: 0.8rem;font-weight: 600;color: #e60012;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;}
.RecommendedProduct ul li .RecommendedProductStop span.StopName{display: inline-block;font-size: 0.6rem;color: #414847;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;width: 100%;vertical-align: middle;}
.RecommendedProduct ul li .RecommendedProductStop span.gostop{display: block;font-size: 0.5rem;color: #414847;margin-left: 0.2rem;vertical-align: middle;text-align: right;padding-right: 0.5rem;background: url(../../../assets/image/gostop.png);background-repeat: no-repeat;background-size: 0.3rem;background-position: right center;}

.Loading{line-height: 1rem;text-align: center;font-size: 0.8rem;margin-top: 2rem;}

.RecommendedProduct{overflow: auto;}
.RecommendedProduct ul{display: inline-block;box-sizing: border-box;padding: 0rem;width: 50%;float: left;}
.RecommendedProduct ul li{width: 100%;}
</style>

